import cart from '@/ui/ui_cart';
import quickCheckout from '@/ui/ui_quick-checkout';

export {
  cart,
  quickCheckout,
};
